<template>
  <div>
    <h2 class="step-name"> Deer Reproduction </h2>

    <div class="step-section">
      <discussion-points title="Deer Comments"
                         comments-field="deer_comments"
                         points="General Deer Comments">
      </discussion-points>
    </div>

    <div class="step-section">
      <div class="row">
        <div class="col-md-6">
          <h3>Last Season</h3>
          <div class="form-group input-box">
            <label>MA Scanning %</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA').deer_ma_scanning_percent" disabled>
          </div>
          <div class="form-group input-box">
            <label>r2 Scanning %</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA').deer_r2_scanning_percent" disabled>
          </div>
        </div>
        <div class="col-md-6">
          <h3>This Season</h3>
          <number-input label="MA Scanning %"
            field-name="deer_ma_scanning_percent">
          </number-input>
          <number-input label="R2 Scanning %"
            field-name="deer_r2_scanning_percent">
          </number-input>

        </div>
      </div>
    </div>

    <div class="step-section">
      <date-input field-name="deer_stag_join_hinds_date"
                  label="Stag join hinds date">
      </date-input>

      <div class="row">
        <div class="col-md-4 col-md-offset-2">
          <radio-input label="Do you want to scan with VetSouth?"
                      field-name="deer_wants_preg_scanning"
                      :add-comment="true"
                      :choices="[
                        {value: 'Yes', display: 'Yes'},
                        {value: 'No', display: 'No'},
                      ]">
          </radio-input>
        </div>

        <div class="col-md-4">
          <date-input field-name="deer_preg_scan_date"
                      label="Scanning date">
          </date-input>
        </div>
      </div>

      <radio-input label="Foetal aging?"
                   field-name="deer_wants_foetal_aging"
                   :choices="[
                     {value: 'Yes', display: 'Yes'},
                     {value: 'No', display: 'No'},
                   ]">
      </radio-input>

      <radio-input label="Weaning"
                   field-name="deer_weaning_at"
                   :choices="[
                     {value: 'Pre-rut', display: 'Pre-rut'},
                     {value: 'Post-rut', display: 'Post-rut'},
                   ]">
      </radio-input>

      <radio-input label="Single Sire Mating?"
                   field-name="deer_single_sire_mating"
                   :add-comment="true"
                   :choices="[
                     {value: 'Yes', display: 'Yes'},
                     {value: 'No', display: 'No'},
                   ]">
      </radio-input>

      <radio-input label="Are you interested in synchrony?"
                   field-name="deer_interested_in_synchrony"
                   :add-comment="true"
                   :choices="[
                     {value: 'Yes', display: 'Yes'},
                     {value: 'No', display: 'No'},
                   ]">
      </radio-input>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'DeerReproduction',
  mixins: [ baseComponent ],
};
</script>

